var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class LetrwingLinkStore {
    constructor() {
        this.mediaType = '';
        this.favicons = [];
        this.title = '';
        this.url = '';
        this.description = '';
        this.images = [];
        makeObservable(this);
    }
    setMediaType(type) {
        this.mediaType = type;
    }
    setFavicons(icons) {
        this.favicons = icons;
    }
    setTitle(title) {
        this.title = title;
    }
    setURL(url) {
        this.url = url;
    }
    setDescription(desc) {
        this.description = desc;
    }
    setImages(images) {
        this.images = images;
    }
    reset() {
        this.mediaType = '';
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], LetrwingLinkStore.prototype, "mediaType", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrwingLinkStore.prototype, "favicons", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrwingLinkStore.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrwingLinkStore.prototype, "url", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrwingLinkStore.prototype, "description", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrwingLinkStore.prototype, "images", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrwingLinkStore.prototype, "setMediaType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrwingLinkStore.prototype, "setFavicons", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrwingLinkStore.prototype, "setTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrwingLinkStore.prototype, "setURL", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrwingLinkStore.prototype, "setDescription", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrwingLinkStore.prototype, "setImages", null);
